import React, { forwardRef, memo } from "react"
import Row from "./Row"
import { MainWrapper } from "../Components"
import { useTextWithBreaksContext } from "../index"

const ClassicTextWithBreaks = forwardRef(function ClassicTextWithBreaks(
	{ parentId = "", className = "", left = false, imageLoadPriority = false, ...props },
	fref,
) {
	const rows = useTextWithBreaksContext("formatted")

	return (
		<MainWrapper ref={fref} className={`${className} text-with-breaks classic`} left={left} {...props}>
			{rows.map((item, index) => (
				<Row key={index} data={item} parentId={parentId} imageLoadPriority={imageLoadPriority} index={index} left={left} />
			))}
		</MainWrapper>
	)
})

export default memo(ClassicTextWithBreaks)
